import { ReleaseStatus } from '../../../sync/__generated/models';

export function releaseStatusName(releaseStatus: ReleaseStatus): string {
  if (releaseStatus === ReleaseStatus.InDevelopment) {
    return 'in development';
  }

  return releaseStatus;
}
